export const initialText = `# Markdown To PDF 
https://mdtopdf.vercel.app/

To convert your Markdown to PDF simply start by typing in the editor or pasting from your clipboard.

## How to Use?

1. **Edit**: Write Markdown text in the editor below.
2. **Import**: Click **"Import MD"** to edit existing files.
3. **Download**: Click **"Download PDF"** for the file.

## Supported Features
- Images
- Emoji
- HTML

### Text Formatting

- *Italic* and **bold** text.
- Headings (H1 to H6).
- Lists (Ordered and Unordered).
- Blockquotes.
- Horizontal rules.
  

## Author
- [Github](https://github.com/rohitashsingh89)
- [Linkedin](https://linkedin.com/in/rohitashsingh89)
- Buy Me a Coffee: [@rohitashsingh89](https://buymeacoffee.com/rohitashsingh89)


## Code Examples

\`\`\`html
<!DOCTYPE html>
<html>
<head>
    <title>Hello World</title>
</head>
<body>
    <h1>Hello, World!</h1>
</body>
</html>
\`\`\`

\`\`\`javascript
function Greetings(name) {
  console.log("Welcome To , " + MD To Pdf Converter + "!");
}
Greetings("World");
\`\`\`


`;
